import React, { useEffect, useState } from 'react';
import { IRoleForUserProps } from './RolesForUser.types';
import { IRoleForUser } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';
import { useLayoutContext } from '../../../Context/Layout.context';
import { getUserRoles } from '../../../services/rolesAndPermissions/rolesAndPermissions.service';
import { AxiosResponse } from 'axios';
import { RolesForUserEdit } from './RolesForUserEdit.component';

export const RolesForUser: React.FC<IRoleForUserProps> = ({ userId, onClose, userName }) => {
  const [roles, setRoles] = useState<IRoleForUser[] | undefined>(undefined);

  const { showLoader, openAlert } = useLayoutContext();

  useEffect(() => {
    showLoader(true);
    getUserRoles(userId)
      .then(
        (response: AxiosResponse<IRoleForUser[]>) => {
          setRoles(response.data);
        },
        () => {
          openAlert('get_error');
        },
      )
      .finally(() => {
        showLoader(false);
      });
  }, []);

  if (!roles) {
    return <></>;
  } else return <RolesForUserEdit userId={userId} userName={userName} roles={roles} onClose={onClose} />;
};
